// extracted by mini-css-extract-plugin
export default {"CardViewer":"CardViewer_CardViewer__CfgIQ","linkText":"CardViewer_linkText__eWQ1Z"};